
module dg.lists {

    export interface IBadgeListOptions extends IListOptions {
        type: 'badge';
        data?: any;
        badgeDefn?: IBadgeDefn;
    }

    export interface IBadgeDefn {
        type: 'badge';
        header?: IBadgeItem[];
        main?: IBadgeItem;
        section?: IBadgeItem[];
        footer?: any;
    }

    export interface IBadgeItem {
        fieldName: string;
    }

    class BadgeListController{
        public static $inject = [
            //'DgDefaultListOptions'
        ];
        public constructor(
            //protected dgDefaultListOptions: IBadgeListOptions
        ) { }

        public options: IBadgeListOptions;

        $onInit = () => {

        };
    }

    angular.module('dg.lists').component('badgeList', {
        bindings: {
            listResult: '<',
            options: '<'
        },
        controller: BadgeListController,
        templateUrl: '/digmo/src/list/badge-list/badge-list.html'
    });
}